// extracted by mini-css-extract-plugin
export var bodySections = "_aq-8";
export var gray = "_aq-7";
export var green = "_aq-4";
export var iconContainer = "_aq-9";
export var iconWidgetContainer = "_aq-1";
export var phoneIcon = "_aq-2";
export var red = "_aq-5";
export var statusDot = "_aq-3";
export var widgetContainer = "_aq-0";
export var yellow = "_aq-6";